var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToastCongratulations2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.5C11.1217 17.5 13.1566 16.6571 14.6569 15.1569C16.1571 13.6566 17 11.6217 17 9.5C17 7.37827 16.1571 5.34344 14.6569 3.84315C13.1566 2.34285 11.1217 1.5 9 1.5C6.87827 1.5 4.84344 2.34285 3.34315 3.84315C1.84285 5.34344 1 7.37827 1 9.5C1 11.6217 1.84285 13.6566 3.34315 15.1569C4.84344 16.6571 6.87827 17.5 9 17.5Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23047 5.19238V8.26931",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69238 6.73071H7.76931",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7695 5.19238V8.26931",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2305 6.73071H13.3074",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73535 10.7307C4.88167 11.7575 5.39355 12.6971 6.17698 13.3768C6.96041 14.0565 7.96278 14.4307 8.99997 14.4307C10.0372 14.4307 11.0395 14.0565 11.823 13.3768C12.6064 12.6971 13.1183 11.7575 13.2646 10.7307H4.73535Z",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastCongratulations2);
export default __webpack_public_path__ + "static/media/toast-congratulations-2.dff34c1f1945889e8e3eaf95636e661f.svg";
export { ForwardRef as ReactComponent };